<template>
  <div
    id="introContainer"
    tabindex="0"
    @keydown="handleKey($event)"
    aria-label="Introduction box"
    aria-live="polite"
    aria-relevant="all"
  >
    <div tabindex="0" id="intro">
      <transition name="up" mode="out-in">
        <div
          v-if="!choice"
          class="step first"
          tabindex="0"
        >
          <p tabindex="0">Welcome to never odd or even. There are two ways to access this website artwork. You can either press [1] to enter a game in which you use sound and resize/drag moving images to match up with illustrations in order to find hidden voice recordings on this website; or you can press [2] to make all elements on this page perceptible without playing through the game to find them.</p>
          <p tabindex="0">You can press [N] at any time to focus the navigation menu, and [A] to bring up more accessibility options.</p>
          <p class="buttons">
            <span
              tabindex="0"
              role="button"
              aria-label="play the game with audio"
              @click.stop="choice = 1"
              @keydown.space="choice = 1"
              @keydown.enter="choice = 1"
            >
              [1] play the game with audio
            </span>
            <span
              tabindex="0"
              role="button"
              aria-label="don't play the game, reveal everything"
              @click.stop="choice = 2"
              @keydown.space="choice = 2"
              @keydown.enter="choice = 2"
            >
              [2] don't play the game, reveal everything
            </span>
          </p>
          <!-- <p>You are now in the map quadrant of this website. If you'd like to navigate to any other quadrant, use the bottom-left side navigation menu.</p> -->
          <!-- <p>Hovering over the icon representing a person moving fast in a wheelchair will reveal more accessibility options.</p> -->
        </div>
        <div
          v-else-if="choice == 1"
          class="step second"
          tabindex="0"
        >
          <p tabindex="0">Happy that you decided to play along with us! To play, drag and resize the moving images to match up with the illustrations. This is also indicated by a background noise becoming silent. Voice recordings will become available that play by tabbing or clicking through them.</p>
          <p class="buttons">
            <span
              tabindex="0"
              role="button"
              aria-label="go back"
              @click.stop="choice = null"
              @keydown.space="choice = null"
              @keydown.enter="choice = null"
            >
              [backspace] back
            </span>
            <span
              tabindex="0"
              role="button"
              aria-label="start game"
              @click.stop="desiresGame()"
              @keydown.space="desiresGame()"
              @keydown.enter="desiresGame()"
            >
              [space] ok
            </span>
          </p>
        </div>
        <div
          v-else-if="choice == 2"
          class="step second"
        >
          <p tabindex="0">Happy that you are listening with us. Please tab through all of the audio recordings as you wish to listen to them.</p>
          <p class="buttons">
            <span
              tabindex="0"
              role="button"
              aria-label="go back"
              @click.stop="choice = null"
              @keydown.space="choice = null"
              @keydown.enter="choice = null"
            >
              (backspace) back
            </span>
            <span
              tabindex="0"
              role="button"
              aria-label="start listening"
              @click.stop="noGame()"
              @keydown.space="noGame()"
              @keydown.enter="noGame()"
            >
              (space) ok
            </span>
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  components: {
  },
  emits: [
    'endIntro'
  ],
  data() {
    return {
      choice: null,
    }
  },
  mounted() {
    // play itro file
   if (this.$store.state.location == 'map') {
     this.$el.focus()
   }
  },
  methods: {

    handleKey(e) {
      if (!this.choice) {
        if (e.key == 1) {
          this.choice = 1
        } else if (e.key == 2) {
          this.choice = 2
        }
      } else {
        if (this.choice == 1) {
          if (e.key == 'Backspace') {
            this.choice = null
          } else if (e.key == ' ' || e.key == 'Return') {
            this.desiresGame()
          }
        } else {
          if (e.key == 'Backspace') {
            this.choice = null
          } else if (e.key == ' ' || e.key == 'Return') {
            this.noGame()
          }
        }
      }
    },

    desiresGame() {
      this.$store.dispatch('access/setOption', { key: 'showEverything', value: false })
      this.$emit('endIntro')
      // play audio file
    },

    noGame() {
      this.$store.dispatch('access/setOption', { key: 'showEverything', value: true })
      this.$emit('endIntro')
      // play audio file
    }
  }
}
</script>

<style scoped>

#introContainer {
  box-sizing: border-box;
  position: absolute;
  top: calc(100%); left: calc(100%);
  width: 100%; height: 100%;
  display: flex;
  z-index: 1000;
  transition: all var(--slow) ease;
}

#introContainer::before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: var(--dark1);
  opacity: 0.8;
}

#intro {
  box-sizing: border-box;
  position: relative;
  margin: auto;
  width: 35em;
  background: var(--dark1);
  padding: 1em;
  transition: all var(--slow) ease;
}

#intro .step p:first-of-type {
  margin-top: 0;
}
#intro .step p:last-of-type {
  margin-bottom: 0;
}

#intro .step .buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

#intro .step .buttons span {
  flex-basis: 50%;
  text-align: center;
  color: var(--light2);
}
#intro .step .buttons span {
  margin: 0 1em;
  text-decoration: underline;
  cursor: pointer;
}
#intro .step .buttons span:hover,
#intro .step .buttons span:focus {
  background: var(--light2) ;
  color: var(--dark2);
}

.up-enter-active,
.up-leave-active {
  transition: all 0.3s ease;
}

.up-enter-from,
.up-leave-to {
  transform: translateY(-5em);
  opacity: 0;
}

</style>
